import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';

export interface DashboardItem {
    ReportID: string;
    ReportName: string;
    Url: string;
    Sort: number;
}

export interface DashboardSection {
    Type: string;
    Items: DashboardItem[];
}

@Injectable({
    providedIn: 'root'
})
export class MenuBuilderService {

    buildAnalyticsMenu(dashboardSections: DashboardSection[], userModules: string[] = []): MenuItem[] {
        const analyticsMenuItems: MenuItem[] = [];

        // Process each dashboard section
        dashboardSections.forEach((section, sectionIndex) => {
            if (section.Type === 'Default') {
                // Add Default type items as individual menu items
                section.Items
                    .sort((a, b) => a.Sort - b.Sort)
                    .forEach((item) => {
                        const menuItem = {
                            label: item.ReportName,
                            routerLink: ['analytics/report', item.ReportID, item.ReportName],
                            id: `2-default-${item.ReportID}`
                        };
                        analyticsMenuItems.push(menuItem);
                    });
            } else {
                // Create submenu for any non-Default type
                const submenuItems: MenuItem[] = section.Items
                    .sort((a, b) => a.Sort - b.Sort)
                    .map((item, itemIndex) => {
                        const subItem = {
                            label: item.ReportName,
                            routerLink: ['analytics/report', item.ReportID, item.ReportName],
                            id: `2-${sectionIndex}-${itemIndex}-${item.ReportID}`
                        };
                        return subItem;
                    });

                const submenu = {
                    label: section.Type,
                    id: `2-section-${sectionIndex}`,
                    items: submenuItems
                };
                analyticsMenuItems.push(submenu);
            }
        });

        // Conditionally add Premium Insights if user has access
        if (userModules && userModules.includes('Analytics.PremiumInsights')) {
            analyticsMenuItems.push({
                label: 'Premium Insights',
                routerLink: ['/analytics/premium-insights'],
                id: '2-premium-insights',
                state: { userModules: ['Analytics.PremiumInsights'] }
            });
        }

        return analyticsMenuItems;
    }
}